import React from 'react';
import {Form} from 'react-form';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import async from 'async';
import ReactTable from 'react-table';
import _ from 'lodash';
import Translate from 'translate';

import {FormGroup, Text, Checkbox} from 'components/FormElements/';
import UserGroupService from 'services/UserGroupService';
import UserService from 'services/UserService';
import {toggleLoading, toggleAlertError} from 'stores/actions/';
import {required} from 'constants/InputErrors';

class UserGroupEdit extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {},
      users: []
    };

    this.entityId = props.match.params.id;
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    if( this.entityId ) this.getData()
  }

  getData() {
    this.props.toggleLoading( true );

    async.parallel( {
      users: this.getUsers.bind( this ),
      data: this.getUserGroup.bind( this )
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( !error ) this.setState( results )
    } )
  }

  getUserGroup( cb ) {
    UserGroupService.getUserGroup( this.entityId )
      .then( ( response ) => cb( response.errors, response.data ) )
  }

  getUsers( cb ) {
    UserService.getUsers( { 'filters[userGroup]': this.entityId } )
      .then( ( response ) => cb( response.errors, response.data ? response.data.data : [] ) )
  }


  submitForm( data ) {
    const { history, toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( data );

    toggleLoading( true );

    const promise = this.entityId ? UserGroupService.updateUserGroup( this.entityId, data ) :
      UserGroupService.saveUserGroup( data );

    promise.then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      return history.push( '/configurations/user-groups' )
    } )
  }

  render() {
    return (
      <div className="box box-default">
        <div className="box-header">{this.entityId ? <Translate id="edit"/> : <Translate id="new"/>} <Translate id="userGroup"/></div>
        <div className="box-body">
          <Form
            defaultValues={this.formData || this.state.data}
            onSubmit={this.submitForm}
            validate={( values ) => {
              return {
                name: required( values.name )
              }
            }}
          >
            {( { submitForm } ) =>
              <form onSubmit={submitForm}>
                <FormGroup>
                  <label><Translate id="name"/></label>
                  <Text field="name" className="form-control"/>
                </FormGroup>

                <FormGroup containerClass="col-md-2 pl-0">
                  <Checkbox field="active" label={<Translate id="active"/>}/>
                </FormGroup>

                <label className="mt-3"><Translate id="users"/></label>
                <ReactTable className="app-table app-table-white"
                            data={this.state.users}
                            pageSize={this.state.users.length}
                            showPagination={false}
                            columns={[
                              { Header: <Translate id="name"/>, accessor: 'name' },
                              { Header: <Translate id="email"/>, accessor: 'email' },
                              {
                                Header: <Translate id="roles"/>, accessor: 'roles', Cell: ( props ) =>
                                <span>{props.value.join( ', ' )}</span>
                              },
                            ]}
                />

                <div className="text-right mt-4">
                  <Link to={`/configurations/user-groups`}>
                    <button className="btn btn-outline-secondary px-4 mr-2">
                      <Translate id="cancel"/>
                    </button>
                  </Link>
                  <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                </div>
              </form>
            }
          </Form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( UserGroupEdit );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/user-groups/edit/index.js